import { render, staticRenderFns } from "./PostBody.component.vue?vue&type=template&id=3bce2a05&"
import script from "./PostBody.component.vue?vue&type=script&lang=js&"
export * from "./PostBody.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports